import React, { useCallback, useEffect, useState } from 'react';
import { setSelectedChemicalsArrayInStore } from "../../../../store/actions";
import { useSelector } from "react-redux";
import { kclRootState } from "../../../../store/gloveSelectorStore";
import { useNavigate, useSearchParams } from "react-router-dom";
import "./Home.scss";
import { ImgChemical, ImgMechanical, ImgInfo, ImgEngIcon, ImgGerIcon, ImgInfoMob } from "../../../../components/dashboard/pages/glovesSelector/glovesSelection";
import { IoIosArrowForward } from "react-icons/io";
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import { useTranslation } from "react-i18next";
import i18next from 'i18next';
import { setLanguageHF } from "../../../../store/actions";
import { setAppLanguageSelector } from "../../../../store/actions";
import { sendAnalyticData, reloadApp } from "../../../common/functions/utils";
import { utilAnalytics } from "../../../common/analytics/analyticsUtil.js";
const Home = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const language = useSelector((state: kclRootState) => state?.glovesSelector?.language);
    const appLanguageFlag = useSelector((state: kclRootState) => state?.glovesSelector?.appLanguageFlag || false);
    const { PAGE_NAVIGATION, API_PATHS } = useSelector((state: kclRootState) => state?.glovesSelector?.config || {});

    const navigateToChemicalSelection = () => {
        navigate(PAGE_NAVIGATION.CHEMICAL_SEARCH);
        window.scrollTo(0, 0);
    };
    const navigateToGlovesSelection = () => {
        navigate(PAGE_NAVIGATION.GLOVES_SELECTOR);
        window.scrollTo(0, 0);
    };
    const navigateToInfoArea = () => {
        navigate(PAGE_NAVIGATION.INFO_AREA);
        window.scrollTo(0, 0);

    };

    useEffect(() => {
        let userLanguage = searchParams?.get("lang");
        setSelectedChemicalsArrayInStore([]);
        if (!appLanguageFlag) {
            if (searchParams?.has("lang")) {
                if (searchParams?.get("lang") == "de") {
                    userLanguage = "de";
                }
            } else {
                userLanguage = navigator.language;
                if (userLanguage == "de-DE") {
                    userLanguage = "de";
                } else {
                    userLanguage = "en";
                }
            }
            if (language == "") {
                setLanguageHF(userLanguage);
                sendAnalyticData("languageSelected", userLanguage, "languageSelected");
                i18next.changeLanguage(userLanguage ? userLanguage : "en");
                if (searchParams?.has("lang")) {
                    navigate(PAGE_NAVIGATION.HOME);
                }
            }
        }
    }, []);

    function handelClick(lang) {
        setLanguageHF(lang);
        setAppLanguageSelector(true);
        sendAnalyticData("languageSelected", lang, "languageSelected");
        i18next.changeLanguage(lang);
    }
    // On admin login click
    const onAdminLoginClick = (e) => {
        reloadApp(API_PATHS.GET_USER_LOGIN + PAGE_NAVIGATION.ADMIN_DASHBOARD);
    };
    return (
        <div className="container gloves-selector">
            <div className="main-title">
                <div className="text-start">
                    <div className="heading">{t("kclGloves.Gloves_Selector")}</div>
                    <p className="">{t("kclGloves.Find_Right_Glove")}</p>
                </div>
                <div className="text-end language-selection">
                    {process.env.REACT_APP_DEV_MODE == "YES" && <div className="button button-primary" onClick={onAdminLoginClick}>{t("kclGloves.Admin")}</div>}
                    <Dropdown>
                        <Dropdown.Toggle>
                            <img src={language === "en" ? ImgEngIcon : ImgGerIcon} alt="English" /> {language === "en" ? "En" : "De"}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item onClick={() => handelClick('en')} href=""><img src={ImgEngIcon} alt="English" /> English</Dropdown.Item>
                            <Dropdown.Item onClick={() => handelClick('de')} href=""><img src={ImgGerIcon} alt="German" /> German</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            </div>

            <div className="row">
                <div className="col-lg-6 col-12 select-chemicals chemical_selection_flow" onClick={navigateToChemicalSelection}>
                    <div className="content">
                        <div>
                            <div className="title">{t("kclGloves.Find_Gloves_by_Chemical")}</div>
                            <p>{t("kclGloves.Find_Gloves_by_Chemical_Desc")}</p>
                        </div>
                        <div className="arrow-icon"><IoIosArrowForward /></div>
                    </div>
                    <img src={ImgChemical} alt="Select chemicals" />
                </div>
                <div className="col-lg-6 col-12 select-chemicals glove_selection_flow" onClick={navigateToGlovesSelection}>
                    <div className="content">
                        <div>
                            <div className="title">{t("kclGloves.Find_Gloves")}</div>
                            <p>{t("kclGloves.Find_Gloves_Desc")}</p>
                        </div>
                        <div className="arrow-icon"><IoIosArrowForward /></div>
                    </div>
                    <img src={ImgMechanical} alt="Select chemicals" />
                </div>
            </div>
            <div className="row">
                <div className="col-lg-12 col-12 select-chemicals info_area_flow" onClick={navigateToInfoArea}>
                    <div className="content">
                        <div>
                            <div className="title">{t("kclGloves.Info_Area")}</div>
                            <p>{t("kclGloves.Info_Area_Desc")}</p>
                        </div>
                        <div className="arrow-icon"><IoIosArrowForward /></div>
                    </div>
                    <div className="info-area"><img src={ImgInfo} alt="Select chemicals" /></div>
                    <div className="info-area-mob"><img src={ImgInfoMob} alt="Select chemicals" /></div>
                </div>
                {/* <div onClick={downloadPDF} className="downloadPdf">Download PDF</div> */}
            </div>
        </div>
    );
};

export default Home;